var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAadGroup = function SvgAadGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#035BDA",
    cx: 15,
    cy: 15,
    r: 15
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.5,
    d: "M13.2 7.8l1.3 1.3-5.1 5L8 12.8zM16.8 7.8l-1.2 1.3 5 5 1.3-1.4z",
    style: {
      fill: "#FFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.5 20.6l4.5-4.5c-.3-.3-.4-.8-.4-1.3 0-1.2 1-2.2 2.2-2.2 1.2 0 2.2 1 2.2 2.2a2.2 2.2 0 0 1-2.9 2l-4.8 4.9.2.9c0 1.3-1.1 2.4-2.5 2.4s-2.5-1-2.5-2.4c0-.4 0-.7.2-1L8 16.8l-.8.2C6 17 5 16 5 14.8c0-1.2 1-2.2 2.2-2.2 1.2 0 2.2 1 2.2 2.2 0 .5-.1.9-.3 1.2l4.5 4.6.4-.3V9.1c-.7-.4-1.2-1-1.2-2C12.8 6 13.8 5 15 5c1.2 0 2.2 1 2.2 2.2 0 .8-.4 1.5-1 1.9v11.3l.3.2zm6.3-4.5c.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3 0 .7.6 1.3 1.3 1.3zm-7.8 8c.9 0 1.6-.7 1.6-1.5 0-.9-.7-1.6-1.6-1.6-.9 0-1.6.7-1.6 1.6 0 .8.7 1.5 1.6 1.5zm0-15.6c.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3 0 .7.6 1.3 1.3 1.3zM7.2 16c.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3 0 .7.6 1.3 1.3 1.3z",
    style: {
      fill: "#FFF"
    }
  }))));
};
export default SvgAadGroup;